export default __webpack_public_path__ + "static/media/BG.93f321a4.PNG";